<div class="why-dental-tour">
  <h2 class="section-title text-black">{{'Why DentalTour?' | translate}}</h2>

  <div class="benefits-grid">
    <div class="benefit-card" *ngFor="let benefit of benefits">
      <div class="icon-container">
        <i class="icon" [ngClass]="benefit.icon" aria-hidden="true"></i>
      </div>
      <div class="content">
        <h3 class="benefit-title">{{ benefit.title | translate }}</h3>
        <p class="benefit-description">{{ benefit.description | translate }}</p>
      </div>
    </div>
  </div>
</div>
